import { BusStopState } from 'owa-mail-list-store';
import { resolve as urlResolve } from 'url';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import getIsDarkModeEnabledInUserSettings from 'owa-dark-mode-option/lib/selectors/getIsDarkModeEnabledInUserSettings';

export default function busStopStateToIconUrlConverter(state: BusStopState): string {
    let toSource;

    if (getIsDarkModeEnabledInUserSettings()) {
        switch (state) {
            case BusStopState.BusStart:
                toSource = require('../svg/darkMode/listview_bus_stop_top_tick_dark.svg');
                break;
            case BusStopState.BusEnd:
                toSource = require('../svg/darkMode/listview_bus_stop_bottom_fill_dark.svg');
                break;
            case BusStopState.NoStop:
                toSource = require('../svg/darkMode/listview_bus_stop_line_dark.svg');
                break;
            case BusStopState.CheckMark:
                toSource = require('../svg/darkMode/listview_bus_stop_single_tick_dark.svg');
                break;
            case BusStopState.BusStop:
                toSource = require('../svg/darkMode/listview_bus_stop_middle_unfilled_dark.svg');
                break;
            case BusStopState.None:
            default:
                return undefined;
        }
    } else {
        switch (state) {
            case BusStopState.BusStart:
                toSource = require('../svg/listview_bus_stop_top_tick.svg');
                break;
            case BusStopState.BusEnd:
                toSource = require('../svg/listview_bus_stop_bottom_filled.svg');
                break;
            case BusStopState.NoStop:
                toSource = require('../svg/listview_bus_stop_line.svg');
                break;
            case BusStopState.CheckMark:
                toSource = require('../svg/listview_bus_stop_single_tick.svg');
                break;
            case BusStopState.BusStop:
                toSource = require('../svg/listview_bus_stop_middle_unfillled.svg');
                break;
            case BusStopState.None:
            default:
                return undefined;
        }
    }
    return urlResolve(getPackageBaseUrl(), toSource);
}
